module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Generator-dc61478dfda43b9ddcead3ff8b9a10ce.svg";